// Copyright (c) 2020 Deere & Company

import './index.scss';

import AuthenticatedPage from '../../common/components/authenticated-page';
import ForecastChange from './forecast-change';
import React from 'react';

function ForecastChangePage () {

    return (
        <AuthenticatedPage className="atp-page atp-forecast-change-page">
            <ForecastChange />
        </AuthenticatedPage>
    );

}
ForecastChangePage.displayNAme = 'ForecastChangePage';

export default ForecastChangePage;
